import { render } from "./BrandArea.vue?vue&type=template&id=0de6c8de"
import script from "./BrandArea.vue?vue&type=script&lang=js"
export * from "./BrandArea.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__